import React from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "next-i18next";
import { IWikifolioAlphaKeyFigureGroupSection } from "src/api/server/wf-detail.types";
import { AlphaWithPerformanceValue } from "src/components/pages/detail/key-figures/components/alpha/alpha-with-performance-value";
import { useDateTimeFormatter } from "src/hooks/formatters/use-date-time-formatter";

interface IOtherAlphasProps {
    creationDate: string;
    alphas: IWikifolioAlphaKeyFigureGroupSection["otherAlphas"];
}

export const OtherAlphas = ({ alphas, creationDate }: IOtherAlphasProps) => {
    const { t } = useTranslation("wf-detail");
    const { formatDateShort } = useDateTimeFormatter();

    return (
        <Typography>
            {t("alpha.other-alphas")}{" "}
            {alphas.map((alpha, alphaIndex) => {
                const text = alpha.useCreationDate
                    ? t("alpha.other-alpha-since", {
                          0: alpha.benchmarkName,
                          1: formatDateShort(creationDate),
                      })
                    : t("alpha.other-alpha-years", {
                          0: alpha.benchmarkName,
                          1: alpha.timespanYears,
                      });

                return (
                    <Typography key={alphaIndex} component="span">
                        <AlphaWithPerformanceValue text={text} value={alpha.alphaEstimateAnnualized} />
                        {alphaIndex < alphas.length - 1 ? ", " : "."}
                    </Typography>
                );
            })}
        </Typography>
    );
};
